import type { AnimationType } from '../../types';
import type { MessageRenderer } from './types';
import { NoneRenderer } from './noneRenderer';
import { LineByLineRenderer } from './lineByLineRenderer';
import { TypewriterRenderer } from './typewriterRenderer';
import { FadeInRenderer } from './fadeInRenderer';
import { ProgressRenderer } from './progressRenderer';

// Singleton instances for each renderer type
const renderers: Record<AnimationType, MessageRenderer> = {
  none: new NoneRenderer(),
  'line-by-line': new LineByLineRenderer(),
  typewriter: new TypewriterRenderer(),
  'fade-in': new FadeInRenderer(),
  progress: new ProgressRenderer(),
};

/**
 * Gets the appropriate renderer for the given animation type
 */
export function getRenderer(animationType: AnimationType = 'none'): MessageRenderer {
  return renderers[animationType] ?? renderers.none;
}

export type { MessageRenderer, RendererConfig, RendererResult, AnimationState } from './types';
export { NoneRenderer } from './noneRenderer';
export { LineByLineRenderer } from './lineByLineRenderer';
export { TypewriterRenderer } from './typewriterRenderer';
export { FadeInRenderer } from './fadeInRenderer';
export { ProgressRenderer } from './progressRenderer';

